export const DEFAULT_BAR_COLORS = ['#5086F3', '#69D19C', '#6E7794'];

export const DEFAULT_BAR_WIDTH = 8;

export const DEFAULT_SERIES_CONFIG = [
  { metricKey: 'full_game_net_units', name: 'Actuals', color: '#5086F3' },
  { metricKey: 'budget_full_game_net_units', name: 'Budget', color: '#69D19C' },
  { metricKey: 'plan_full_game_net_units', name: 'Plan', color: '#6E7794' },
];
